import Button from '@/components/base/Button';
import { servicesHeroImage } from '@/mocks/services';

export default function ServicesHero() {
  return (
    <section className="px-4 md:px-6 lg:px-20 pt-10 md:pt-16 pb-16 md:pb-20">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-center">
        <div className="lg:col-span-5 fade-up">
          <p className="text-xs md:text-[13px] font-medium tracking-[0.14em] text-secondary-500 mb-4">OUR SERVICES</p>
          <h1 className="font-heading text-[38px] md:text-[56px] lg:text-[64px] leading-[1.06] font-medium tracking-tight">The Right Clean for Every Home.</h1>
          <p className="mt-6 text-base md:text-lg leading-[1.6] text-foreground-600 max-w-md">From regular upkeep to a more thorough refresh, discover thoughtful cleaning services designed around your space.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button href="/contact">Request a Quote <i className="ri-arrow-right-line" /></Button>
            <Button href="#service-collection" variant="ghost">View Services</Button>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div data-reveal="image" className="w-full h-[300px] md:h-[440px] lg:h-[540px] rounded-[24px] overflow-hidden bg-background-200">
            <img loading="eager" fetchPriority="high" src={servicesHeroImage} alt="CLEARY cleaner wiping a kitchen counter in a bright home" title="CLEARY residential cleaning services" className="w-full h-full object-cover object-top" />
          </div>
        </div>
      </div>
    </section>
  );
}